import React from "react";
import classes from "./InputTextCopy.module.scss";
// import CheckIcon from "@mui/icons-material/Check";
import ToggleButton from "@mui/material/ToggleButton";
import Card from "@mui/material/Card";
import { CardActionArea } from "@mui/material";

const InputTextCopy = ({
  small = null,
  classSon = null,
  defaultValue = null,
  ...rest
}) => {
  const [selected, setSelected] = React.useState(false);

  const copyFunc = () => {
    let copyText = document.getElementById("chavePix");
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
  };

  return (
    <Card onClick={copyFunc} className={`${classes.InputTextCopy} ${classSon}`}>
      <CardActionArea
        data-testid="payment_pix_textCopy_btn"
        onClick={() => setSelected(true)}
        style={{
          display: "flex",
          // flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <input
          className={classes.InputText}
          type="chavePix"
          defaultValue={defaultValue}
          name="chavePix"
          disabled
          id="chavePix"
        />
        <div
          data-testid={`payment_pix_${selected ? "copied" : "copy"}_btn`}
          value="check"
          className={classes.ToggleButton}
          style={{
            color: "#FFF",
            backgroundColor: "#662D91",
          }}
        >
          {selected ? "copiado" : "copiar"}
        </div>
      </CardActionArea>
    </Card>
  );
};

export default InputTextCopy;
